<template>
  <div class="tep-contain ">
    <div class="flex" v-show='this.totalPages'>
      <li class="up" @click="prevOrNext(-1)" v-show='preshow'>上一页</li>
      <li class="page"  v-for="(item, index) in pages"  :key="index" :class="{actived: item === currentPage}"    @click="select(item)" >{{item}}</li>
      <li class="up" @click="prevOrNext(1)" v-show='nextshow'>下一页</li>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: Number,
      default: () => { return 0 }
    },
    currentpage: {
      type: Number,
      default: () => { return 1 }
    }
  },
  data () {
    return {
      currentPage: this.currentpage,
      totalPages: this.total
    }
  },
  computed: {
    pages () {
      const c = this.currentPage
      const t = this.totalPages
      if (t <= 7) return [...new Array(t)].map((v, i) => i + 1)
      if (c <= 5) {
        return [1, 2, 3, 4, 5, 6, 7, '...', t] // 第一种情况
      } else if (c >= t - 4) {
        return [1, '...', t - 6, t - 5, t - 4, t - 3, t - 2, t - 1, t] // 第二种情况
      } else {
        return [1, '...', c - 2, c - 1, c, c + 1, c + 2, '...', t] // 第三种情况
      }
    },
    nextshow () {
      return this.currentPage !== this.totalPages
    },
    preshow () {
      return this.currentPage !== 1
    }
  },
  methods: {
    select (item) {
      this.currentPage = item
      this.$emit('my-event', this.currentPage)
    },
    prevOrNext (n) {
      this.currentPage += n
    }
  }

}
</script>
<style scoped>
  .flex{
    display: flex;
    max-width:46rem;
    margin:auto;
  }
  li{
    list-style: none;
  }
  .page{
    width:1.5625rem;
    height:1.5625rem;
    text-align:center;
    line-height: 1.5625rem;
    font-size:.875rem;
    color:#6a7176;
    margin-left:1.25rem;
    cursor: default;
    font-style:italic;
  }
  .page:nth-of-type(1){
    margin-left:0;
  }
  .up{
    color:#0080cc;
    font-size:.875rem;
    font-style:italic;
    cursor: default;
    margin:0 2.875rem;
  }
  .actived {
      background-color: #0080cc;
      color: #fff;
      border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/vue-pagition/vue-pagition.vue